export default "__VITE_ASSET__BgFLjuOC__"